import { useCallback } from "react";
import type { CellKeyDownEvent } from "ag-grid-enterprise";

/**
 * Up and down arrows walk the rows and carry the selection with them, the way the logbook
 * grid does. Without it the arrows only move the focused cell and the detail stays behind.
 */
export const useArrowRowNavigation = <T>(onSelect: (row: T) => void) =>
	useCallback(
		(event: CellKeyDownEvent<T>) => {
			const { api, node, event: keyEvent } = event;
			if (!keyEvent) return;
			const key = (keyEvent as KeyboardEvent).key;
			if (key !== "ArrowUp" && key !== "ArrowDown") return;

			keyEvent.preventDefault();
			const currentIndex = node.rowIndex ?? -1;
			const nextIndex = key === "ArrowUp" ? currentIndex - 1 : currentIndex + 1;
			const nextNode = api.getDisplayedRowAtIndex(nextIndex);
			if (!nextNode?.data) return;

			nextNode.setSelected(true);
			api.ensureIndexVisible(nextIndex);
			onSelect(nextNode.data);
		},
		[onSelect],
	);
